module.exports = __webpack_public_path__ + "static/media/CheckTick.9fd23558.svg";